<template>
  <div class="membership">
    <div class="membership__left-col">
      <avatar
        :name="membership.team.name"
        size="md"
        class="avatar"
      />

      <div>
        <div class="membership__name">
          {{ membership.team.name }}
        </div>
        <div class="membership__email">{{ membership.createdAt }}</div>
      </div>
    </div>

    <div class="membership__right-col">
      <div
        v-t="'c.membership.label.owner'"
        v-if="membership.role === 'owner'"
        class="membership__owner-label"
      />
      <radio-bar-input
        v-else
        v-model="role"
        :options="options"
        name="radioBarInput1"
        @change="updateRole"
      />

      <dropdown-input
        :options="dropdownOptions"
        position="right"
        theme="primary"
        @select="handleDropdownSelect"
      >
        <button-input>
          <font-awesome-icon icon="cog" />
          <font-awesome-icon icon="angle-down" />
        </button-input>
      </dropdown-input>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import fullName from '@/filters/fullName'
import FormMixin from '@/mixins/forms/Form'
import Avatar from '@/components/ui/Avatar'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Membership',
  mixins: [FormMixin],
  components: {
    Avatar,
    FontAwesomeIcon
  },
  filters: {
    fullName
  },
  props: {
    membership: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      role: 'editor'
    }
  },
  computed: {
    membershipRole: {
      get () { return this.role },
      set (role) { this.role = role }
    },
    options () {
      return [
        { isWarning: false, icon: 'user', value: 'editor' },
        { isWarning: true, icon: 'bolt', value: 'admin' }
      ]
    },
    dropdownOptions () {
      return [
        { label: 'Bearbeiten', value: 'edit', icon: 'edit' },
        { label: 'Löschen', value: 'delete', icon: 'trash' }
      ]
    }
  },
  methods: {
    ...mapActions([
      'updateMembershipRole'
    ]),
    updateRole (role) {
      this.updateMembershipRole({
        membership: this.membership,
        role: role
      })
    },
    handleDropdownSelect ({ value }) {
      switch (value) {
        case 'edit':
          window.alert('edit')
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Mitglied löschen',
            message: `Das Mitglied ${this.team.name} wirklich löschen?`,
            callback: () => {
              window.alert('delete')
              // this.destroyTeam(this.team.id)
              //   .then(this.fetchTeams)
              //   .then(this.closeConfirmModal)
            }
          })
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  },
  created () {
    this.role = this.$props.membership.role
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'

.membership
  position: relative;
  border-top: 1px solid #E1E6EB;
  border-bottom: 1px solid #E1E6EB;
  height: rem-calc(100);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__left-col,
  &__right-col
    display: flex;
    align-items: center;

  &__owner-label
    +font-size(15, 42);
    text-align: center;
    width: rem-calc(100);
    height: rem-calc(42);
    background: $color-grey-1;
    border-radius: 3px;
    display: inline-block;
    margin-right: rem-calc(10);
    cursor: default;


  &__name
    +font-size(15, 15);
    font-family: $font-1;
    margin-bottom: rem-calc(5);
    font-weight: 500;

  &__link
    color: #000;

  &__email
    +font-size(12, 14)
    color: $color-grey-2;

.membership + .membership
  border-top: 0;

.avatar
  margin-right: rem-calc(15);

.radio-bar-input
  display: inline-flex;
  margin-right: rem-calc(10);
</style>





// WEBPACK FOOTER //
// src/components/memberships/Membership.vue